import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { remove } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cancelSelectByHand } from 'store/actions/deliverableActions';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';

export const DeliverableSubmissionCancellation = () => {
  const [t] = useTranslation();
  const { state, dispatch } = useAppState();
  const open = useSelector((state) => state.dialogs.deliverableSubmissionCancellation);

  const handleClose = () => {
    dispatch(closeDialogAction('deliverableSubmissionCancellation'));
  };

  const handleConfirm = () => {
    dispatch(cancelSelectByHand());
    if (state.dialogs.data.confirm) state.dialogs.data.confirm();
    handleClose();
  };
  return (
    <>
      <Dialog style={{ maxHeight: 435 }} maxWidth="xs" open={open}>
        <DialogTitle>{t('Submission cancellation')}</DialogTitle>
        <DialogContent>
          <div>
            {t(
              'The selected deliverable(s) are already validated. Canceling the submission, will cancel the associated validation.'
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            {t('Cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={handleConfirm}>
            {t('OK')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeliverableSubmissionCancellation;
